const listaDeTratativasOpcoes = (state) => {
    return state.tratativas_opcoes;
}

const loadingTratativasOpcoes = (state) => {
    return state.buscando
}

export {
    listaDeTratativasOpcoes,
    loadingTratativasOpcoes
}